import type { ReactNode } from 'react';
import { useEffect } from 'react';

import { AuthProvider as WebKitAuthProvider } from '@lotushealth/web_kit/auth';

import { handleSessionUserChanged, toSessionUser } from '@/entities/session';
import { SessionTimeoutHost } from '@/features/session-timeout';
import { auth } from '@/shared';
import { logger } from '@/shared';

import { AuthContext } from './useAuth';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  useEffect(() => {
    logger.info('auth provider mounted', { source: 'app/providers' });
  }, []);

  return (
    <WebKitAuthProvider
      auth={auth}
      context={AuthContext}
      mapUser={toSessionUser}
      onUserChanged={handleSessionUserChanged}
    >
      <SessionTimeoutHost />
      {children}
    </WebKitAuthProvider>
  );
}
